<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '项目档案']"></breadcrumb>

    <div class="container">
      <el-row>
        <el-col :span="12" class="info-title">项目信息</el-col>
        <!--        Z-->
      </el-row>
      <div class="proj-con">
        <el-descriptions :column="3">
          <el-descriptions-item label="客户名称">{{
              projectInfo.customerName
            }}</el-descriptions-item>
          <el-descriptions-item label="项目名称">{{
              projectInfo.projectName
            }}</el-descriptions-item>
          <el-descriptions-item label="所在省市">{{ projectInfo.province }}-{{
              projectInfo.city
            }}</el-descriptions-item>
          <el-descriptions-item label="商机号/报价号">{{
              projectInfo.quote
            }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ projectInfo.remark }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-row>
        <el-col :span="14" style="margin-top: 14px" class="info-title" id="projectOff">
          <div>
            官方项目档案
          </div>
        </el-col>
        <el-col :span="10" class="archives">
          <div @click="offProject">{{ offTitle }}<img :src="offImg"/></div>
        </el-col>
      </el-row>

      <authority :list = offList ref="auth"></authority>
      <!--某某子公司项目档案-->
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/pc/Breadcrumb'
import authority from '@/components/pc/authority'
import { mapMutations } from 'vuex'
import moment from "moment";
import { pDetailsList, detailsList } from '@/api/projectManage'
export default {
  name: 'pDetails',
  components: {
    Breadcrumb,
    authority
  },
  data() {
    return {
      businessId: null,
      projectInfo: {
        customerName: '', //客户
        projectName: '', //项目
        province: '', //省份
        city: '', //城市
        quote: '', //报价号
        coverUrl: '', //封面图片
        createTime: '',
        taskShowStatus: false
      },
      uploadLoading: false,
      downloading: false,
      list: [],
      copyTaskId: null,
      myImg:require('../../assets/imgs/icon_arrow_down@2x.png'),
      offImg:require('../../assets/imgs/icon_arrow_down@2x.png'),
      subImg:require('../../assets/imgs/icon_arrow_down@2x.png'),
      myList:[],
      myTitle:'收起',
      offList:[],
      offTitle:'收起',
      subList:[],
      subTitle:'收起',
      userId:'',
      show:false,
      taskList: [],
      pageNum:1,
      pageSize:5,
      total:0,
      dialog:false
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  mounted() {
    localStorage.removeItem('Checklist')
    this.changeMenuStatus({ value: 1 })
    this.businessId = this.$route.params.id
    this.getBusinessInfo()
    this.getDocumentTaskList()
    this.offProject()
    setTimeout(()=>{
      if(this.$route.params.num == 1){
        this.scrollId('project', this.myProject)
        this.myProject()
      }else if(this.$route.params.num == 2){
        this.scrollId('projectOff', this.offProject)
        this.offProject()
      }else if(this.$route.params.num == 3){
        this.scrollId('projectZ', this.subTitle)
        this.subProject()
      }
    }, 500 )
  },
  methods: {
    ...mapMutations(['changeMenuStatus']),
    goProject(index){
      this.dialog = false
      this.$router.push({path: '/manage/newproject', query: {projectId: this.taskList[index].projectId, taskId: this.taskList[index].taskId}});
    },
    sizeChangeHandleHis() {
      this.taskProject()
    },
    // 当前页
    currentChangeHandleHis() {
      this.taskProject()
    },
    scrollId(project, title){
      document.getElementById(`${project}`).scrollIntoView()
      title = '展开'
    },
    handleEditProject() {
      this.$router.push(`/manage/editproject/${this.businessId}`)
    },
    goprojectEditing(){
      this.$router.push(`/manage/projectEditing/${this.businessId}`)
    },
    //官方档案
    offProject(){
      console.log(this.$route.params.id === 'null')
      const params = {
        pid: this.$route.params.id === 'null'? null : this.$route.params.id,
        bid: ''
      }
      console.log(params)
      pDetailsList(params).then((res) => {
        if (this.offTitle == '收起') {
          this.offList = []
          this.offTitle = '展开'
          this.offImg = require('../../assets/imgs/icon_arrow_down@2x.png')
          res.data.forEach((item, index) => {
            item.fileUrlImg = require('../../assets/imgs/pic_document_add_bg_352@2x.png')
            if (index < 3) {
              item.title = item.name
              item.show = true
              this.offList.push(item)
            }
          })
        } else if (this.offTitle == '展开') {
          res.data.forEach((item, index) => {
            item.fileUrlImg = require('../../assets/imgs/pic_document_add_bg_352@2x.png')
            item.title = item.name
            item.show = true
            if (index > 2) {
              this.offList.push(item)
            }
          })
          this.offTitle = '收起'
          this.offImg = require('../../assets/imgs/icon_arrow_up@2x.png')
        }
      })
    },
    handleSelectTask(item) {
      if (item.status == '未发布' || item.status == '线下文档') {
        return
      }
      if (item.id === this.copyTaskId) {
        this.copyTaskId = null
      } else {
        this.copyTaskId = item.id
      }
    },
    handlePreviewTask(item) {
      if (item.status == '已发布' || item.status == '线下文档') {
        this.$request.taskPreview(item.id).then((res) => {
          if (res.code == 200) {
            console.log(res, '预览数据')
            // window.open(res.data)
            this.$openWindow(res.data)
          }
        })
      }
    },
    handleUploadDocument() {
      const uploadFileDom = document.querySelector('#uploadFile')
      uploadFileDom.value = ''
      uploadFileDom.click()
    },
    //跳转到模板页
    creatDocument() {
      this.$router.push(`/manage/newdoc/${this.businessId}`)
    },
    goEdit(item) {
      localStorage.removeItem('cachetags')
      //0 默认不显示右侧和数据
      this.$router.push({
        path: `/manage/editdocument/${item.id}/${this.businessId}`,
        query: { hasDefaultSelected: item.hasDefaultSelected}
      })
    },
    getDocumentTaskList() {
      this.$request.getBusinessInfo(this.businessId).then((res) => {
        if (res.code == 200) {
          console.log(res, 345)
          this.userId = res.data.userId
          // console.log(sessionStorage.getItem('userId'))
          console.log(res.data.userId, sessionStorage.getItem('userId'), 123)
          if(this.userId == sessionStorage.getItem('userId')){
            this.show = false
          }else {
            this.show = true
          }
          this.list = res.data
        }
      })
    },
    getBusinessInfo() {
      detailsList(this.businessId).then((res) => {
        if (res.code == 200) {
          this.projectInfo = res.data
        }
      })
    },
    handleCopyTask() {
      if (this.copyTaskId == null) {
        this.$message.warning('请先选择要复制得文档.')
        return
      }
      this.$request.copyTask(this.copyTaskId).then((res) => {
        if (res.code == 200) {
          this.$message.success('复制成功')
          this.getDocumentTaskList()
        }
      })
    },
    handleNewProject() {
      this.$router.push(`/manage/newproject/${this.businessId}/${this.copyTaskId}`)
    },
    handleDownload(item) {
      this.downloading = true
      this.$request.downloadTaskFile(item.id).then((res) => {
        if (res.code == 200) {
          // window.open(res.data)
          this.$openWindow(res.data)
        }
        this.downloading = false
      })
      // this.$request.downloadTaskFile(item.id).then((file) => {
      //   let content = file
      //   // 组装a标签
      //   let elink = document.createElement('a')
      //   // 设置下载文件名
      //   elink.download = new Date().getTime() + '.pptx'

      //   elink.style.display = 'none'
      //   let blob = new Blob([content], {
      //     type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      //   })
      //   elink.href = URL.createObjectURL(blob)
      //   document.body.appendChild(elink)
      //   elink.click()
      //   document.body.removeChild(elink)
      //   this.downloading = false
      // })
    }
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#F4F4F5;')
  }
}
</script>

<style lang="less" scoped>
.archives{
  text-align: right;
  line-height: 16px;
  display: flex;
  justify-content: end;
  cursor: pointer;
  margin-top: 25px;
  &>div img{
    width: 16px;
    height: 16px;
  }
}
.container {
  padding: 0 136px;

  .info-title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    margin-top: 48px;
    &>.el-button{
      height: 32px;
    }
  }

  .proj-con {
    padding: 29px 24px 19px 24px;
    background-color: #fafafa;
    margin-top: 16px;
    margin-bottom: 50px;
    border-radius: 8px;

    ::v-deep .el-descriptions-item__cell {
      padding: 0 0 10px 0;
    }

    ::v-deep .el-descriptions__body {
      background-color: transparent;
    }

    ::v-deep .el-descriptions-item__content {
      color: #e60027;
    }
  }

  .upload-btn {
    display: none;
  }

  .doc-list {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;

    &>.item {
      flex: 0 0 240px;
      height: 220px;
      margin-right: 54px;
      margin-bottom: 20px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &>.img {
        width: 240px;
        height: 136px;
        border-radius: 12px;
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        border: 1px solid #eee;

        &.add {
          background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat center center / 56px auto;
          background-color: #f0f0f0;
        }

        &>.type {
          width: 80px;
          height: 80px;
          transform: translate(-40px, -40px) rotate(-45deg);

          &.s1 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '已发布';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #52c41a;
              text-align: center;
              box-sizing: border-box;
            }
          }

          &.s2 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '未发布';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #d9d9d9;
              text-align: center;
              box-sizing: border-box;
            }
          }

          &.s3 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '线下文档';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #52c41a;
              text-align: center;
              box-sizing: border-box;
            }
          }
        }
      }

      &>.imgurl {
        width: 240px;
        height: 136px;
      }

      &>.info-con {
        padding-top: 12px;

        &>div {
          color: rgba(0, 0, 0, 0.85);
        }

        &>p {
          padding-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          margin: 0;
        }
      }
    }
  }
}

.bott {
  display: flex;
  margin-top: 6px;
  height: 24px;
  align-items: center;

  &>.info {
    flex: 1;
    color: rgba(0, 0, 0, 0.45);

    &.publish {
      color: #52c41a;
    }
  }

  &>.edit-con {
    flex: 0 0 auto;

    &>i {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
      margin: 0 5px;

      &:hover {
        color: #e60027;
      }

      &.el-icon-loading {
        cursor: default;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    &>.eye {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_see_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.download {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_download_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.edit {
      display: inline-block;
      background: url('~@/assets/imgs/icon_edit_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
      cursor: pointer;
    }
  }
}

.ed {
  margin: 5px auto;
}
</style>
